import React from 'react'
import "./Descargas.scss"
import { Button, Icon, Image } from 'semantic-ui-react'
import logo from "../../img/logotransparente.png"
import bannerCollect from "../../img/prueba.png"
import { useAuth } from '../../context/authContext'
import ReproductorDescargas from '../../Components/reproductorDescargas/ReproductorDescargas'
import {useHistory} from 'react-router-dom'
import { toast } from 'react-toastify'



function Descargas() {
    const {setShowModal,setContentModal,setTitleModal}=useAuth()
    const history = useHistory()

    const handleVideo = (type)=>{

        if(type ==="descargar"){
            setShowModal(true)
            setTitleModal("¿ Como descargar ?")
            setContentModal(<ReproductorDescargas
                url="https://playerafl.com/v/dm3Rjme2Wkb0FLJ"
            />)
            
        }
        if(type ==="origenes"){
            window.location.href="https://www.youtube.com/watch?v=u7P-7pUQxps"
            
        }
        if(type ==="instalacion"){
            setShowModal(true)
            setTitleModal("Instalar Play Af")
            setContentModal(<ReproductorDescargas
                url="http://playerafl.com/v/VvVPo82n5Pa9ndx"
            />)
            
        }
        if(type ==="actualizar"){
            setShowModal(true)
            setTitleModal("Actualizar Play Af")
            setContentModal(<ReproductorDescargas
                url="https://playerafl.com/v/00fc6w1VBziHfFk"
            />)
            
        }
        if(type ==="desinstalar"){
            setShowModal(true)
            setTitleModal("Desinstalar Play Af")
            setContentModal(<ReproductorDescargas
                url="https://playerafl.com/v/rSu19wkDPV2Pwef"
            />)
            
        }


    }

    const handleDescargar = ()=>{
        const link = "https://www.mediafire.com/file/szb9417rf5okxju/PlayAf_10.0.0.apk/file"
        window.location.href=link
    }




  return (
    <div className='containerDescargas' >
      <div className='containerLogoDescargas' >
        <Image
            src={logo}
            className='logoDescargas'
        />

      </div>
        <div className='containerBannerDescargas' >
            <div className='left' >
                <div className='leftRight' >
                    <div className='containerDescription' >

                        <h2 className='title' >Descargar Play Af para peliculas, series y mucho mas</h2>
                        <div className='conatinerButtom' >

                            <div className='ContainerButtomdescargar' >

                                <Button
                                    content="Descargar Play Af"
                                    className='buttomDescargar'
                                    icon={
                                        <Icon
                                            name='mobile alternate'
                                            
                                            
                                        />
                                    }
                                    onClick={()=>handleDescargar()}
                                    
                                    
                                />
                                <div className='ContainerVerificada' >
                                    <Icon
                                        name='shield'
                                        className='iconSegurity'
                                    />
                                    <span className='textoSegurity' >Seguridad verificada</span>
                                </div>
                            </div>



                            <Button
                                content="¿Necesitas ayuda?"
                                className='buttomAyuda'
                                onClick={()=>toast.error("Aun no disponible😰")}
                                icon={
                                    <Icon
                                        name='help circle'
                                    />
                                }
                            />
                        </div>
                    </div>

                </div>
                

            </div>

            <div className='right' >
                <Image
                    src={bannerCollect}
                    className='imagebannercollect'
                />
            </div>
        </div>
        
        <div className='containerProblemas' >
            <div className='containerTexto' >
                <h2 className='TextoSubtitle' >play af es gratis: como instalar y actualizar</h2>

            </div>
        </div>

        <div className='containerNuevoUsuario' >
            <div className='ContainerTextoNuevoUsuario' >
                <h2 className='TextoSubtitulo' >Soy Nuevo Usuario: Como Instalar</h2>

            </div>
        </div>
        <div className='containerPasos' >
            <div className='PrimerPaso' >
                <div className='box' >

                    <h2  className='titlePaso' >Descargar Play Af</h2>
                    <h2  className='descriptionPaso' >
                        Presione el boton de "Descargar Play Af"
                        en el sitio web y siga los pasos de instalacion
                    </h2>
                    <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("descargar")}
                    />

                </div>

            </div>
            <div className='PrimerPaso' >
                <div className='box' >

                        <h2  className='titlePaso' >Origenes Desconocidos</h2>
                        <h2  className='descriptionPaso' >
                            Activar "Origines Desconocidos" permite instalar
                            nuestra "APK",omitir si esta esta activado
                        </h2>
                        <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("origenes")}

                    />
                        
                </div>

            </div>
            <div className='PrimerPaso' >
                <div className='box' >

                        <h2  className='titlePaso' >¿ Problemas De Instalacion ?</h2>
                        <h2  className='descriptionPaso' >
                            Si aun no puedes instalar la APP, sigue los pasos del video aqui abajo
                        </h2>
                        <span>👇</span>
                        <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("instalacion")}

                    />

                </div>

            </div>
            
        </div>

        <div className='containerNuevoUsuario' >
            <div className='ContainerTextoNuevoUsuario' >
                <h2 className='TextoSubtitulo' >Soy Usuario Desde La PlayStore: Como Actualizar </h2>

            </div>
        </div>
        <div className='containerPasos' >
            <div className='PrimerPaso' >
                <div className='box' >

                    <h2  className='titlePaso' >Desinstalar Play Af</h2>
                    <h2  className='descriptionPaso' >
                        Desinstale la aplicacion "Play Af" para poder instalar
                        la nueva actualizacion
                    </h2>
                    <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("desinstalar")}
                    />

                </div>

            </div>
            <div className='PrimerPaso' >
                <div className='box' >

                    <h2  className='titlePaso' >Descargar Play Af</h2>
                    <h2  className='descriptionPaso' >
                        Presione el boton de "Descargar Play Af" en la parte superior
                        siga los pasos de la instalacion
                    </h2>
                    <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("descargar")}
                    />

                </div>

            </div>
            <div className='PrimerPaso' >
                <div className='box' >

                        <h2  className='titlePaso' >Origenes Desconocidos</h2>
                        <h2  className='descriptionPaso' >
                            Activar "Origines Desconocidos" permite instalar
                            nuestra "APK",omitir si esta esta activado
                        </h2>
                        <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("origenes")}

                    />
                        
                </div>

            </div>
            <div className='PrimerPaso' >
                <div className='box' >

                        <h2  className='titlePaso' >¿ Problemas De Actualizacion ?</h2>
                        <h2  className='descriptionPaso' >
                            Si aun no puedes actualizar la APP, sigue los pasos del video aqui abajo
                        </h2>
                        <span>👇</span>
                        <Button
                        content="Ver video"
                        className='botomVerVideo'
                        onClick={()=>handleVideo("actualizar")}

                    />

                </div>

            </div>
            
        </div>

        
    </div>
  )
}

export default Descargas
